// extracted by mini-css-extract-plugin
export default {"workGridContainer":"WorkGrid_workGridContainer__1lfpd"};